import React, { useState } from "react";
import styled from "@emotion/styled";

import theme from "src/theme";
import { ClickAwayListener, Divider } from "@material-ui/core";
import { ChevronDown, ChevronUp } from "react-feather";

const Container = styled.div`
  position: relative;
  cursor: pointer;
  font-family: Roboto;

  padding: ${theme.spacing(1)};

  border-radius: 8px 8px 0 0;

  background: ${(props) =>
    props.isOpened ? theme.palette.common.white : "transparent"};
  box-shadow: ${(props) => (props.isOpened ? theme.shadows[10] : 0)};
`;

const Header = styled.div`
  display: flex;
  align-items: center;

  color: ${(props) =>
    props.isOpened ? theme.palette.common.black : theme.palette.common.white};
`;

const Select = styled.ul`
  position: absolute;
  left: 0;

  list-style: none;
  color: black;

  width: 100%;

  /* padding: ${theme.spacing(1)}; */

  display: ${(props) => (props.isOpened ? "block" : "none")};
  background: ${(props) =>
    props.isOpened ? theme.palette.common.white : "transparent"};
  box-shadow: ${(props) => (props.isOpened ? theme.shadows[10] : 0)};

  transition: all 300ms ease-in-out;
`;

const SelectItem = styled.li`
  /* padding: ${theme.spacing(1)}; */
  padding: 16px;
`;

const Title = styled.span`
  padding: 8px;
  flex: 1;
`;

function SelectBox({
  identifyBy,
  identifyName,
  initialValue,
  onChange,
  options,
}) {
  const [open, setOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState();

  const toggleSelect = () => {
    setOpen(!open);
  };

  const handleItemClick = (e) => {
    setSelectedItem(e.target.dataset.value);
    onChange(e.target.dataset.value);
  };

  const closeSelect = () => {
    if (!open) return;

    setOpen(false);
  };

  return (
    <ClickAwayListener onClickAway={closeSelect}>
      <Container isOpened={open} onClick={toggleSelect}>
        <Header isOpened={open}>
          <Title> {initialValue[identifyName]} </Title>
          {open ? <ChevronUp /> : <ChevronDown />}
        </Header>
        {open && <Divider />}
        <Select isOpened={open}>
          {options
            .filter(
              (item) =>
                item[identifyBy] !== Number(selectedItem) &&
                initialValue[identifyBy] !== item[identifyBy]
            )
            .map((item) => (
              <SelectItem
                key={item[identifyBy]}
                onClick={handleItemClick}
                data-value={item[identifyBy]}
              >
                {item[identifyName]}
              </SelectItem>
            ))}
        </Select>
      </Container>
    </ClickAwayListener>
  );
}

export default SelectBox;
